import { createTheme, MantineColorsTuple, virtualColor } from "@mantine/core"

const brandBlue: MantineColorsTuple = [
  "#e6f3ff",
  "#c7e3ff",
  "#93c5fd",
  "#60a5fa",
  "#3b82f6",
  "#2563eb",
  "#1d4ed8",
  "#1e40af",
  "#1e3a8a",
  "#172554",
]

const brandRed: MantineColorsTuple = [
  "#fef2f2",
  "#fee2e2",
  "#fecaca",
  "#fca5a5",
  "#f87171",
  "#ef4444",
  "#dc2626",
  "#b91c1c",
  "#991b1b",
  "#7f1d1d",
]

const brandOrange: MantineColorsTuple = [
  "#fff7ed",
  "#ffedd5",
  "#fed7aa",
  "#fdba74",
  "#fb923c",
  "#f97316",
  "#ea580c",
  "#c2410c",
  "#9a3412",
  "#7c2d12",
]

const brandTeal: MantineColorsTuple = [
  "#f0fdfa",
  "#ccfbf1",
  "#99f6e4",
  "#5eead4",
  "#2dd4bf",
  "#14b8a6",
  "#0d9488",
  "#0f766e",
  "#115e59",
  "#134e4a",
]

export const theme = createTheme({
  primaryColor: "teal",
  colors: {
    blue: brandBlue,
    red: brandRed,
    orange: brandOrange,
    teal: brandTeal,
    // Virtual color that changes between light and dark modes
    background: virtualColor({
      name: "background",
      dark: "dark.8",
      light: "gray.0",
    }),
  },
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: "600",
    sizes: {
      h1: { fontSize: "2.5rem", lineHeight: "1.2" },
      h2: { fontSize: "2rem", lineHeight: "1.25" },
      h3: { fontSize: "1.5rem", lineHeight: "1.33" },
      h4: { fontSize: "1.25rem", lineHeight: "1.4" },
      h5: { fontSize: "1.125rem", lineHeight: "1.45" },
      h6: { fontSize: "1rem", lineHeight: "1.5" },
    },
  },
  fontSizes: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    md: "1rem", // 16px (base)
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    xxl: "1.5rem", // 24px
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65",
  },
  spacing: {
    xs: "0.5rem", // 8px
    sm: "0.75rem", // 12px
    md: "1rem", // 16px
    lg: "1.25rem", // 20px
    xl: "1.5rem", // 24px
    xxl: "2rem", // 32px
  },
  defaultRadius: "md",
  cursorType: "pointer",
  components: {
    Paper: {
      defaultProps: {
        withBorder: true,
        p: "md",
      },
      styles: {
        root: {
          backdropFilter: "blur(20px)",
        },
      },
    },
    Button: {
      defaultProps: {
        size: "md",
      },
      styles: {
        root: {
          transition: "all 0.2s ease",
          fontWeight: "500",
          letterSpacing: "-0.005em",
          "&:hover": {
            transform: "translateY(-1px)",
          },
        },
      },
    },
    Title: {
      styles: {
        root: {
          letterSpacing: "var(--mantine-heading-letter-spacing)",
        },
      },
    },
    Text: {
      styles: {
        root: {
          lineHeight: "var(--mantine-line-height-md)",
        },
      },
    },
    Container: {
      defaultProps: {
        size: "lg",
      },
      styles: {
        root: {
          paddingLeft: "var(--mantine-spacing-md)",
          paddingRight: "var(--mantine-spacing-md)",
        },
      },
    },
  },
})
